/**
 * A steady colour for someone's initial, so each child keeps the same colour on
 * Home, in the code sheet and on Contul meu › Familie. Muted on purpose: these
 * sit next to the gym's own colour and must not compete with it.
 */
const PALETTE = ['#B8695A', '#6A8F7B', '#5B6E7A', '#8C7BB0', '#4F79A8', '#A8894F', '#C2848F']

export function personColor(id: string): string {
  let hash = 0
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0
  return PALETTE[hash % PALETTE.length]
}
